// PrefillLoadingModal.tsx
// Full-screen overlay shown while the CCH return prefill lookup is in progress.

import React from 'react';

interface Props {
  clientName: string;
  onSkip: () => void;
}

export default function PrefillLoadingModal({ clientName, onSkip }: Props) {
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,.75)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      backdropFilter: 'blur(3px)',
    }}>
      <div style={{
        background: 'var(--surface, #1e2030)',
        border: '1px solid var(--border)',
        borderRadius: 16,
        padding: '40px 44px',
        width: 420, maxWidth: '92vw',
        boxShadow: '0 20px 60px rgba(0,0,0,.7)',
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        gap: 0,
      }}>

        {/* Spinner */}
        <div style={{ marginBottom: 28 }}>
          <svg width="52" height="52" viewBox="0 0 52 52" fill="none">
            {/* Track */}
            <circle cx="26" cy="26" r="21" stroke="rgba(122,162,255,.15)" strokeWidth="4" />
            {/* Arc */}
            <circle
              cx="26" cy="26" r="21"
              stroke="rgba(122,162,255,.85)"
              strokeWidth="4"
              strokeLinecap="round"
              strokeDasharray="66 66"
              strokeDashoffset="33"
              style={{ animation: 'poaSpinArc 0.9s linear infinite', transformOrigin: '26px 26px' }}
            />
          </svg>
        </div>

        {/* Text */}
        <div style={{ fontSize: 17, fontWeight: 700, marginBottom: 8, textAlign: 'center' }}>
          Looking up return data
        </div>
        <div style={{ fontSize: 13, color: 'var(--muted)', textAlign: 'center', lineHeight: 1.6, marginBottom: 10 }}>
          Searching CCH for the most recent filing information for
        </div>
        <div style={{
          fontSize: 14, fontWeight: 600, color: 'var(--accent)',
          background: 'rgba(122,162,255,.1)', border: '1px solid rgba(122,162,255,.2)',
          borderRadius: 8, padding: '6px 14px', marginBottom: 28,
        }}>
          {clientName}
        </div>

        <div style={{ fontSize: 12, color: 'var(--muted)', textAlign: 'center', lineHeight: 1.6, marginBottom: 32 }}>
          Taxpayer name, address, and ID will be pre-filled from their latest return.
        </div>

        {/* Skip button */}
        <div style={{ alignSelf: 'flex-end' }}>
          <button
            className="btn"
            onClick={onSkip}
            style={{ fontSize: 12, color: 'var(--muted)' }}
          >
            Skip lookup and type manually →
          </button>
        </div>
      </div>

      {/* Keyframe for the spinner arc */}
      <style>{`
        @keyframes poaSpinArc {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
